import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Paper,
  CircularProgress,
  Box,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import api from "../services/api";

const normalizeObs = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();

export default function Comissao() {
  const [comissoes, setComissoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [buscaCliente, setBuscaCliente] = useState("");

  useEffect(() => {
    carregarComissoes();
  }, []);

  const carregarComissoes = async (filtroCliente = "") => {
    setLoading(true);
    setErro("");

    try {
      const vendedorRaw = localStorage.getItem("codigoVendedor");
      
      if (!vendedorRaw) {
        setErro("CÃ³digo do vendedor nÃ£o encontrado.");
        setComissoes([]);
        setLoading(false);
        return;
      }

      const vendedor = vendedorRaw.replace(/^"|"$/g, '');
      
      console.log("DEBUG - CÃ³digo vendedor do localStorage:", vendedorRaw);
      console.log("DEBUG - CÃ³digo vendedor apÃ³s replace:", vendedor);
      
      const params = filtroCliente ? { clienteFiltro: filtroCliente } : {};
      console.log("DEBUG - Chamando API:", `/comissoes/${vendedor}`, "Params:", params);
      
      const resp = await api.get(`/comissoes/${vendedor}`, { params });
      
      console.log("DEBUG - Resposta da API:", resp.data);

      if (resp.status === 401 || resp.data?.message) {
        setErro(resp.data?.message || "Erro ao carregar comissÃµes.");
        setComissoes([]);
        setLoading(false);
        return;
      }

      let dados = Array.isArray(resp.data) ? resp.data : [];
      setComissoes(dados);
    } catch (e) {
      console.error("Erro ao carregar comissÃµes:", e);
      
      if (e.response?.status === 401) {
        setErro(e.response?.data?.message || "CÃ³digo do vendedor nÃ£o encontrado no token.");
      } else {
        setErro("NÃ£o foi possÃ­vel carregar as comissÃµes.");
      }
      
      setComissoes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBuscaCliente = (e) => {
    const valor = e.target.value;
    setBuscaCliente(valor);
    carregarComissoes(valor);
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor || 0);
  };

  const formatarData = (data) => {
    if (!data) return "";
    const d = new Date(data);
    return d.toLocaleDateString("pt-BR");
  };

  const calcularTotalVendas = () => {
    return comissoes
      .filter((c) => normalizeObs(c.observacao) === "VENDA DE MERCADORIA")
      .reduce((soma, c) => soma + Number(c.valorTotal || 0), 0);
  };

  const calcularTotalVales = () => {
    return comissoes
      .filter((c) => normalizeObs(c.observacao) === "VALE - VENDEDORES")
      .reduce((soma, c) => soma + Number(c.valorTotal || 0), 0);
  };

  const calcularTotalDevolucoesEEstornos = () => {
    return comissoes
      .filter((c) => {
        const obs = normalizeObs(c.observacao);
        return obs === "DEVOLUCAO DE VENDA" || obs === "ESTORNO - CANCELAMENTO PEDIDO";
      })
      .reduce((soma, c) => soma + Number(c.valorTotal || 0), 0);
  };

  const totalVendas = calcularTotalVendas();
  const totalVales = calcularTotalVales();
  const totalDevolucoesEEstornos = calcularTotalDevolucoesEEstornos();
  const totalGeral = totalVendas - totalVales - totalDevolucoesEEstornos;

  const comissoesExibir = comissoes.filter((c) => {
    const obs = normalizeObs(c.observacao);
    return (
      obs === "VENDA DE MERCADORIA" ||
      obs === "VALE - VENDEDORES" ||
      obs === "DEVOLUCAO DE VENDA" ||
      obs === "ESTORNO - CANCELAMENTO PEDIDO"
    );
  });

  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        ComissÃµes â€” Pedidos em Aberto
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Buscar cliente"
              value={buscaCliente}
              onChange={handleBuscaCliente}
              placeholder="Digite o nome do cliente"
            />
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2, bgcolor: "#e8f5e9" }}>
            <Typography variant="body2">Total Vendas</Typography>
            <Typography variant="h6">{formatarMoeda(totalVendas)}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2, bgcolor: "#fff4e5" }}>
            <Typography variant="body2">Total Vales</Typography>
            <Typography variant="h6">{formatarMoeda(totalVales)}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2, bgcolor: "#fdecea" }}>
            <Typography variant="body2">Total Devolucoes + Estornos</Typography>
            <Typography variant="h6">{formatarMoeda(totalDevolucoesEEstornos)}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={3}>
          <Paper sx={{ p: 2, bgcolor: "#e3f2fd" }}>
            <Typography variant="body2">Total Geral</Typography>
            <Typography variant="h6" fontWeight="bold">
              {formatarMoeda(totalGeral)}
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {loading && (
        <Box display="flex" justifyContent="center" my={5}>
          <CircularProgress />
        </Box>
      )}

      {erro && (
        <Paper sx={{ p: 3, bgcolor: "#fdecea", mb: 3 }}>
          <Typography color="error">{erro}</Typography>
        </Paper>
      )}

      {!loading && !erro && comissoesExibir.length === 0 && (
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Typography>Nenhuma comissÃ£o encontrada.</Typography>
        </Paper>
      )}

      {!loading && !erro && comissoesExibir.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell><strong>Documento</strong></TableCell>
                <TableCell><strong>Cliente</strong></TableCell>
                <TableCell align="right"><strong>Valor</strong></TableCell>
                <TableCell><strong>Vendedor</strong></TableCell>
                <TableCell align="center"><strong>Data</strong></TableCell>
                <TableCell align="center"><strong>Tipo</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comissoesExibir.map((com, idx) => {
                const obs = normalizeObs(com.observacao);
                const isDevolucaoOuEstorno =
                  obs === "DEVOLUCAO DE VENDA" || obs === "ESTORNO - CANCELAMENTO PEDIDO";
                const isVale = obs === "VALE - VENDEDORES";
                const descricao =
                  obs === "DEVOLUCAO DE VENDA"
                    ? `DEVOLUCAO - ${com.entNome}`
                    : obs === "ESTORNO - CANCELAMENTO PEDIDO"
                    ? `ESTORNO - ${com.entNome}`
                    : isVale
                    ? `VALE - ${com.entNome}`
                    : com.entNome;

                return (
                  <TableRow 
                    key={idx}
                    sx={{ 
                      bgcolor: isDevolucaoOuEstorno || isVale ? "#fdecea" : "transparent",
                      "&:hover": { bgcolor: "#f5f5f5" }
                    }}
                  >
                    <TableCell>{com.numeroDocumento}</TableCell>
                    <TableCell>{descricao}</TableCell>
                    <TableCell align="right">
                      {formatarMoeda(com.valorTotal)}
                    </TableCell>
                    <TableCell>{com.vendedor}</TableCell>
                    <TableCell align="center">
                      {formatarData(com.dataMovimento)}
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        component="span"
                        sx={{
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          bgcolor: isDevolucaoOuEstorno || isVale ? "#ffcdd2" : "#c8e6c9",
                          color: isDevolucaoOuEstorno || isVale ? "#c62828" : "#2e7d32",
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                        }}
                      >
                        {com.tipoMovEstq}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
}

